import { RegisterComponents } from "../components/RegisterComponents.js";
import { InitState, RegisterStateUpdatedListener } from "../state/State.js";
import { initReducers } from "../state/Reducers.js";
import { inject } from "@vercel/analytics";

// New code

function registerListeners() {
  RegisterStateUpdatedListener((e) => {
    console.log("🧙‍♂️: State updated", e.detail);
  });
}

initReducers();
InitState();
RegisterComponents();
registerListeners();

inject();
